// src/auth/msalConfig.js

export const msalConfig = {
  auth: {
    clientId:    "4634796c-e1af-491e-a395-5ab67dc4fe22",
    authority:   "https://login.microsoftonline.com/0285f4de-20dd-4b15-9c39-c902cf4e96b0",
    redirectUri: "https://kind-pond-099ddf400.7.azurestaticapps.net",
  },
  cache: {
    cacheLocation:        "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Scopes for initial login
export const loginRequest = {
  scopes: ["User.Read"],
};

// Scopes for Intune device data
export const intuneRequest = {
  scopes: ["https://graph.microsoft.com/DeviceManagementManagedDevices.Read.All"],
};

// Scopes for Defender for Endpoint
export const defenderRequest = {
  scopes: ["https://api.securitycenter.microsoft.com/.default"],
};
